import { Step } from '../components/steps/Step';
import { OnboardingFlows } from './common';

export const contentTypeLearningAndDevelopmentDepartment: Step = {
    id: OnboardingFlows.UseCases,
    title: 'How do you plan to use D-ID?',
    showCondition: {
        stepId: OnboardingFlows.NewDepartment,
        selectedOption: 'Learning & Development',
    },
    multiSelect: false,
    randomize: true,
    options: [
        {
            label: 'Interactive conversational Avatars',
        },
        {
            label: 'Compliance training',
        },
        {
            label: 'Employee onboarding',
        },
        {
            label: 'Sales enablement',
        },
        {
            label: 'Operations training',
        },
        {
            label: 'Employee training',
        },
        {
            label: 'Soft-skills training',
        },
        {
            label: 'Knowledge base',
        },
        {
            label: 'Policy update',
        },
        {
            label: 'Other',
        },
    ],
};
